module.exports = __webpack_public_path__ + "static/img/doc-guide-2.b5c1df6.png";